import { render } from "./News53.vue?vue&type=template&id=5af82a52"
import script from "./News53.vue?vue&type=script&lang=js"
export * from "./News53.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__